import { render, staticRenderFns } from "./addSchool.vue?vue&type=template&id=3a1a1208&scoped=true&"
import script from "./addSchool.js?vue&type=script&lang=js&"
export * from "./addSchool.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1a1208",
  null
  
)

export default component.exports